"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountdownMessage = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var _Layout = require("../Layout");

var _Typography = require("../Typography");

var _useCountdown2 = require("./useCountdown");

var defaultBgColor = 'sonar';
var primaryBgColor = 'rambutan';
var StyledDivisor = (0, _styledComponents.default)(_Typography.Text).withConfig({
  displayName: "CountdownMessage__StyledDivisor",
  componentId: "sc-1vlkb06-0"
})((0, _css.default)({
  lineHeight: 1
}));

var CountdownMessage = function CountdownMessage(_ref) {
  var dueDate = _ref.dueDate,
      message = _ref.message,
      daysLabel = _ref.daysLabel,
      hoursLabel = _ref.hoursLabel,
      minutesLabel = _ref.minutesLabel,
      secondsLabel = _ref.secondsLabel,
      showErrorOnEnd = _ref.showErrorOnEnd,
      onOverdue = _ref.onOverdue,
      props = (0, _objectWithoutProperties2.default)(_ref, ["dueDate", "message", "daysLabel", "hoursLabel", "minutesLabel", "secondsLabel", "showErrorOnEnd", "onOverdue"]);

  var _useState = (0, _react.useState)(defaultBgColor),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      backgroundColor = _useState2[0],
      setBackgroundColor = _useState2[1];

  var _useCountdown = (0, _useCountdown2.useCountdown)({
    dueDate: dueDate
  }),
      days = _useCountdown.days,
      hours = _useCountdown.hours,
      minutes = _useCountdown.minutes,
      seconds = _useCountdown.seconds,
      timeRemaining = _useCountdown.timeRemaining;

  var getTextProps = function getTextProps() {
    var fontSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'small';
    return {
      size: fontSize,
      fontWeight: 'medium'
    };
  };

  var getItem = function getItem(_ref2) {
    var value = _ref2.value,
        label = _ref2.label;
    return _react.default.createElement(_Layout.Flex, {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    }, _react.default.createElement(_Typography.Text, getTextProps(), value), _react.default.createElement(_Typography.Text, getTextProps('micro'), label));
  };

  var getDivisor = function getDivisor() {
    return _react.default.createElement(StyledDivisor, getTextProps(), ".");
  };

  (0, _react.useEffect)(function () {
    if (showErrorOnEnd) {
      if (timeRemaining === 0) {
        setBackgroundColor(primaryBgColor);
      } else if (backgroundColor === primaryBgColor) {
        setBackgroundColor(defaultBgColor);
      }
    }

    if (timeRemaining === 0 && typeof onOverdue === 'function') {
      onOverdue();
    }
  }, [timeRemaining, showErrorOnEnd]);
  return _react.default.createElement(_Layout.Flex, (0, _extends2.default)({
    width: "100%",
    alignItems: "center",
    justifyContent: "center"
  }, props, {
    padding: 4,
    backgroundColor: backgroundColor,
    color: "coco"
  }), _react.default.createElement(_Typography.Text, (0, _extends2.default)({
    as: "h4"
  }, getTextProps(), {
    textAlign: "center"
  }), message), _react.default.createElement(_Layout.Grid, {
    marginLeft: [4, 5, 5],
    gridColumnGap: 1
  }, _react.default.createElement(_Layout.GridItem, {
    gridRow: 1
  }, getItem({
    value: days,
    label: daysLabel
  })), _react.default.createElement(_Layout.GridItem, {
    gridRow: 1
  }, getDivisor()), _react.default.createElement(_Layout.GridItem, {
    gridRow: 1
  }, getItem({
    value: hours,
    label: hoursLabel
  })), _react.default.createElement(_Layout.GridItem, {
    gridRow: 1
  }, getDivisor()), _react.default.createElement(_Layout.GridItem, {
    gridRow: 1
  }, getItem({
    value: minutes,
    label: minutesLabel
  })), _react.default.createElement(_Layout.GridItem, {
    gridRow: 1
  }, getDivisor()), _react.default.createElement(_Layout.GridItem, {
    gridRow: 1
  }, getItem({
    value: seconds,
    label: secondsLabel
  }))));
};

exports.CountdownMessage = CountdownMessage;
CountdownMessage.defaultProps = {
  showErrorOnEnd: false,
  onOverdue: null
};